import React, { useState } from "react"
import minus from "@images/icons/minusPink.svg"
import plus from "@images/icons/plusPink.svg"
import * as styles from "./SupplierFAQs.module.scss"

const FAQ = ({ item }) => {
  const [isActive, updateIsActive] = useState(false)

  const toggleActive = () => {
    updateIsActive((prev) => !prev)
  }

  return (
    <div className={`${styles.faq}`}>
      <button type="button" onClick={toggleActive}>
        <img src={isActive ? minus : plus} alt="" />
        {item.questiontext || item.testimonialname}
      </button>
      <p className={isActive ? styles.active : ""}>{item.answertext || item.testimonialtext}</p>
    </div>
  )
}

const SupplierFAQs = (props) => (
  <div className={`${styles.faqs}`}>
    {props.elements.length
      ? props.elements.map((item, i) => <FAQ item={item} key={`faq ${i}`} />)
      : null}
  </div>
)

export default SupplierFAQs
